import {LIST_ALERT_MAPPING, CREATE_ALERT_MAPPING, UPDATE_ALERT_MAPPING, DELETE_ALERT_MAPPING} from "../constant";
import axios from 'axios';
import * as REPO from '../helper/main'

const localKey = 'token';

export const getListAlertMapping = () => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(LIST_ALERT_MAPPING, config_token);
};

export const postAlertMapping = data => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.post(CREATE_ALERT_MAPPING, data, config_token);
};

export const updateAlertMapping = (data, id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.put(UPDATE_ALERT_MAPPING + id, data, config_token);
};

export const deleteAlertMapping = (id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.delete(DELETE_ALERT_MAPPING + id, config_token);
};
